module.exports = require("@foundit/quick-search/dist/QuickSearch");